import AxiosInstance from "./Axios";
import Cookies from "universal-cookie";

// --------------------------------------------------------
// ENDPOINTS
// --------------------------------------------------------
const API_BASE = "/admin/request-status";

function toUnixSeconds(input) {
  if (input == null || input === "") return null;

  if (typeof input === "number" && Number.isFinite(input)) {
    return input > 1e12 ? Math.floor(input / 1000) : Math.floor(input);
  }

  if (typeof input === "string" && input.trim()) {
    const n = Number(input.trim());
    if (Number.isFinite(n)) return toUnixSeconds(n);
  }

  if (input instanceof Date && !Number.isNaN(input.getTime())) {
    return Math.floor(input.getTime() / 1000);
  }

  return null;
}

export async function getRequestStatusHistory({ from, to } = {}) {
  const fromSec = toUnixSeconds(from);
  const toSec = toUnixSeconds(to);

  if (!fromSec || !toSec) {
    console.error(
      `Invalid params: "from" and "to" are required unix seconds. Received from=${String(from)}, to=${String(
        to
      )}`
    );
    return null;
  }

  try {
    const cookies = new Cookies();
    const token = cookies.get("token");
    const query = new URLSearchParams({
      type: "history",
      from: String(fromSec),
      to: String(toSec),
    }).toString();

    const res = await AxiosInstance.get(`${API_BASE}?${query}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      },
    });

    return res;
  } catch (error) {
    console.error("error in request:", error);
    return null;
  }
}

const RequestStatusHistoryService = {
  getRequestStatusHistory,
};

export default RequestStatusHistoryService;
